// extracted by mini-css-extract-plugin
export default {"wrapper":"alertDescription_wrapper__yJxso","img":"alertDescription_img__kOrjk","contents":"alertDescription_contents__CUgxb","firstLine":"alertDescription_firstLine__4I3D7"};